module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Mirek_Kozlowski.fd5feadf.jpg";